// extracted by mini-css-extract-plugin
module.exports = {"main":"Item_main__3vmCV","rank":"Item_rank__2sISV","phone":"Item_phone__5Yku0"};